require('./angulartics');
module.exports = 'angulartics';



//////////////////
// WEBPACK FOOTER
// ../~/angulartics/src/index.js
// module id = 41
// module chunks = 0 1